import { useQuery } from '@tanstack/react-query';

import { INTERVIEW_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';
import { useStaffSession } from '@/hooks/auth';

const useApplicantInterview = (applicantID: string) => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: INTERVIEW_KEYS.list({ applicantID }),
    queryFn: async () => errorUtils.unwrap(await interviewsService.listInterviews(applicantID)),
    enabled: applicantID.length > 0 && session?.stage === 'ready',
  });
};

export {
  useApplicantInterview,
};
